module.exports = __webpack_public_path__ + "static/media/tally.4ef89301.svg";